import { z } from 'zod';
import { ConsultantLoginTypeEnum } from '../enums/consultantLoginTypeEnum';

export function useTranslatedConsultantLoginSchema() {
    return z.object({
        loginType: z.enum([
            ConsultantLoginTypeEnum.MyCustomers,
            ConsultantLoginTypeEnum.Intranet,
        ]),
    });
}
